module.exports = __webpack_public_path__ + "static/the-churchill-factor-22042ed15e260b9dea4a548b78eab6b5.jpg";